import type { Client } from '@fitness-force/models';

export interface ClientSearchResponse {
  originalQuery: string;
  autocompleteSuggestion: string;
  language: string;
  baseurl: string;
  searchResults: {
    clients: {
      items: Client[];
      statistics: Client[];
      total_items: number;
      total_pages: number;
      current_page: number;
    };
    invoices: {
      items: Invoice[];
      statistics: Invoice[];
      total_items: number;
      total_pages: number;
      current_page: number;
    };
    actions: {
      items: Action[];
      statistics: Action[];
      total_items: number;
      total_pages: number;
      current_page: number;
    };
    kbdocs: {
      items: KbDoc[];
      statistics: KbDoc[];
      total_items: number;
      total_pages: number;
      current_page: number;
    };
    company: {
      items: Company[];
      statistics: Company[];
      total_items: number;
      total_pages: number;
      current_page: number;
    };
    client_communications: {
      items: ClientCommunication[];
      statistics: ClientCommunication[];
      total_items: number;
      total_pages: number;
      current_page: number;
    };
  };
  total_items: number;
  total_pages: number;
  current_page: number;
}

export interface Invoice {
  tenantid: number;
  companyid: number;
  invoiceid: string;
  clientid: string;
  purchasedate: string;
  invoiceamt: number;
  balanceamt: number;
}

export interface Action {
  action: string;
  action_url: string;
  action_desc: string;
}

export interface KbDoc {
  url: string;
  title: string;
  subtitle: string;
  description: string;
}

export interface Company {
  id: number;
  uuid: string;
  status: 'InActive' | 'Active';
  name_pri_langs: string;
  name_sec_lang: string;
  subdomain: string;
  purchase_portal_enable: boolean;
  member_portal_enable: boolean;
  pri_lang: string;
  is_sec_lang: boolean;
  sec_lang: string;
  email_id: string;
  website: string;
  phone1: string;
  phone2: string;
  address1: string;
  address2: string;
  about_us_pri_lang: string;
  about_us_sec_lang: string;
  is_privacy_policy_url: boolean;
  is_terms_of_service_url: boolean;
  privacy_policy: string;
  terms_of_service: string;
  privacy_policy_url: string;
  terms_of_service_url: string;
  account_manager_id: number;
  imglogo: string;
}

export interface ClientCommunication {
  company_id: number;
  tenant_id: number;
  client_id: number;
  staff_id: number;
  thread_id: string;
  message_id: string;
  reply_id: string;
  communication_type: 'None' | string;
  direction: 'Incoming' | 'Outgoing';
  from: string;
  to: string;
  cc: string;
  bcc: string;
  subject: string;
  message: string;
  track_mode: 'StaffWebApp' | string;
  created_by: number;
  created_date: string;
  updated_by: number;
  updated_date: string;
  conversation_date: string;
}

export interface OmniSearchResponseByTenantId {
  search_results: SearchResults;
}

export interface SearchResults {
  total_items: number;
  tenant_level_clients: TenantLevelClient[];
}

export interface TenantLevelClient {
  prospects_and_trials: ProspectsAndTrials;
  active_clients_and_non_members: ActiveClientsAndNonMembers;
  ex_clients_and_non_members: ExClientsAndNonMembers;
  blocked_clients: BlockedClients;
}

export interface ProspectsAndTrials {
  total_items: number;
  items: Client[];
}

export interface ActiveClientsAndNonMembers {
  total_items: number;
  items: Client[];
}

export interface ExClientsAndNonMembers {
  total_items: number;
  items: Client[];
}

export interface BlockedClients {
  total_items: number;
  items: Client[];
}

export enum OmniSearchProvider {
  Clients = 1,
  Actions = 2,
  KbDocuments = 3,
  ProspectsAndTrials = 4, // Represents prospects and trial users
  ActiveClientsAndNonMembers = 5, // Represents active clients and active non-member clients
  ExClientsAndNonMembers = 6, // Represents ex-clients and ex-non-member clients
  BlockedClients = 7, //
}

export interface OmniSearchResponseForClient {
  items: Client[];
  statistics: Client[];
  total_items: number;
  total_pages: number;
  current_page: number;
}
